import PageLayout from '../../components/Page/layout';
import Queue from '../../components/Queue';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import { useEffect } from 'react';
import { useState } from 'react';
import PeakPost from '../../components/Queue/peak';
import Button from '../../components/Button';

import { motion } from 'framer-motion';
import { getActivePlan } from '../../utils/helpers';
import TimezoneButton from '../../components/Queue/TimezoneButton';
import { PencilIcon } from '@heroicons/react/outline';
import { NextSeo } from 'next-seo';

export default function QueuePage() {
  const [timezone, setTimezone] = useState(null);
  const [userID, setUserID] = useState(null);
  const [peakOpen, setPeakOpen] = useState(false);
  const [activeID, setActiveID] = useState(null);

  const [username, setUsername] = useState(null);

  const [activeSlotUnix, setActiveSlotUnix] = useState(null);
  const [activeSlotPretty, setActiveSlotPretty] = useState(null);

  const [productName, setProductName] = useState('Free Plan');

  const [refreshQueue, setRefreshQueue] = useState(false);
  const [passSlotEditor, setPassSlotEditor] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (userInfo) {
      if (userInfo) {
        setUserID(userInfo.uid);
        getUsername(userInfo.uid);
        getActivePlan(userInfo.uid, function (plan) {
          setProductName(plan.name);
        });
      } else {
        setUserID(null);
      }
    });
  }, []);

  useEffect(() => {
    userID && getTimezone();
  }, [userID]);

  const getUsername = (uid) => {
    firebase
      .database()
      .ref('users/' + uid)
      .child('gallery')
      .once('value', (snapshot) => {
        if (snapshot.exists()) {
          setUsername(snapshot.val().username);
        }
      });
  };

  const getTimezone = () => {
    const db = firebase.database();
    const ref = db.ref(`users/${userID}/schedule/timezone`);
    ref.once('value', function (snapshot) {
      if (snapshot.exists()) {
        setTimezone(snapshot.val());
      } else {
        setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
      }
    });
  };

  const draftSelected = (draftID) => {
    console.log(draftID);
    setActiveID(draftID);
    setPeakOpen(true);
  };

  const saveTimezone = (timezone) => {
    setTimezone(timezone);
    if (timezone && userID) {
      firebase
        .database()
        .ref('users/' + userID + '/schedule')
        .child('timezone')
        .set(timezone)
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });
    } else {
    }
  };

  return (
    <>
      <head>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@typeshare_co" />
        <meta
          name="twitter:title"
          content="Typeshare | Everything you need to start writing online."
        />
        <meta
          name="twitter:description"
          content={
            'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.'
          }
        />
        <meta name="twitter:creator" content="@samjshore" />
        <meta name="twitter:image" content="https://typeshare.co/ts2-og.png" />
      </head>
      <NextSeo
        title={'Queue'}
        titleTemplate={'%s | Typeshare'}
        description={
          'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.'
        }
        additionalLinkTags={[
          {
            rel: 'icon',
            href: '/favicon.ico',
          },
        ]}
        openGraph={{
          type: 'website',
          title: 'Typeshare | Everything you need to start writing online.',
          description:
            'Templates so you never stare at a blank page again. One-click publishing to millions of readers. Analytics to track performance.',
          url: `https://typeshare.co/`,
          images: [
            {
              url: '/ts2-og.png',
              width: 1200,
              height: 630,
              alt: 'Og Image Alt',
            },
          ],
        }}
      />

      <PeakPost
        refreshQueue={() => setRefreshQueue(true)}
        postID={activeID}
        userID={userID}
        open={peakOpen}
        setOpen={setPeakOpen}
        activeSlotPretty={activeSlotPretty}
        activeSlotUnix={activeSlotUnix}
        slug={username}
        productName={productName}
      />

      <motion.div
        layout
        className={`relative mx-auto mt-12 flex max-w-screen-sm flex-col space-y-8 px-8`}
      >
        <div className="flex w-full flex-row flex-wrap items-center justify-center gap-2 md:justify-between">
          <h1 className="hidden text-3xl font-bold tracking-tight md:flex">
            Queue
          </h1>

          <div className=" flex flex-row items-center justify-end space-x-2">
            <Button
              click={() => setPassSlotEditor(true)}
              prefix={<PencilIcon className="-mr-1 h-4 w-4" />}
              size={'mini'}
              variant={'outline'}
            >
              Edit Slots
            </Button>

            <TimezoneButton timezone={timezone} setTimezone={saveTimezone} />
          </div>
        </div>

        <Queue
          galleryUsername={username}
          passSlotEditor={passSlotEditor}
          setPassSlotEditor={setPassSlotEditor}
          setRefreshQueue={setRefreshQueue}
          refreshQueue={refreshQueue}
          draftSelected={(id) => draftSelected(id)}
          layout={'list'}
          timezone={timezone}
          setTimezone={setTimezone}
          userID={userID}
          passRefresh={() => null}
          activeSlotPretty={activeSlotPretty}
          activeSlotUnix={activeSlotUnix}
          setActiveSlotPretty={setActiveSlotPretty}
          setActiveSlotUnix={setActiveSlotUnix}
        />
      </motion.div>
    </>
  );
}
